(function () {
  'use strict';

  var TTL_DAYS = 30;
  var TTL_MS = TTL_DAYS * 24 * 60 * 60 * 1000;
  var COOKIE_MAX_AGE = TTL_DAYS * 24 * 60 * 60;
  var STORAGE_PREFIX = 'mantemi_poas_';
  var CLICK_IDS = ['gclid', 'fbclid', 'gbraid', 'wbraid'];
  var syncing = false;
  var scheduled = false;
  var originalFetch = window.fetch.bind(window);

  function nowIso() {
    return new Date().toISOString();
  }

  function setCookie(name, value) {
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) +
      '; Max-Age=' + COOKIE_MAX_AGE + '; Path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  function clearCookie(name) {
    document.cookie = encodeURIComponent(name) + '=; Max-Age=0; Path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  function getCookie(name) {
    var needle = encodeURIComponent(name) + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(needle) === 0) {
        return decodeURIComponent(parts[i].slice(needle.length));
      }
    }
    return '';
  }

  function setStored(name, value) {
    if (!value) return;
    try { localStorage.setItem(STORAGE_PREFIX + name, value); } catch (e) {}
    setCookie(STORAGE_PREFIX + name, value);
  }

  function getStored(name) {
    try {
      var localValue = localStorage.getItem(STORAGE_PREFIX + name);
      if (localValue) return localValue;
    } catch (e) {}
    return getCookie(STORAGE_PREFIX + name);
  }

  function clearStored(name) {
    try { localStorage.removeItem(STORAGE_PREFIX + name); } catch (e) {}
    clearCookie(STORAGE_PREFIX + name);
  }

  function isFreshTimestamp(timestamp) {
    if (!timestamp) return true;
    var time = Date.parse(timestamp);
    return Number.isFinite(time) && Date.now() - time <= TTL_MS;
  }

  function captureUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var capturedAt = nowIso();

    CLICK_IDS.forEach(function (key) {
      var value = (params.get(key) || '').trim();
      if (!value) return;
      setStored(key, value);
      setStored(key + '_timestamp', capturedAt);
    });
  }

  function buildPoasAttributes() {
    var attrs = {};
    var hasClick = false;

    CLICK_IDS.forEach(function (key) {
      var value = getStored(key);
      if (!value) return;
      var timestamp = getStored(key + '_timestamp');
      if (!isFreshTimestamp(timestamp)) {
        clearStored(key);
        clearStored(key + '_timestamp');
        return;
      }
      attrs[key] = value;
      attrs[key + '_timestamp'] = timestamp || nowIso();
      hasClick = true;
    });

    if (!hasClick) return null;
    attrs.user_agent = navigator.userAgent || '';
    return attrs;
  }

  function differs(current, next) {
    return Object.keys(next).some(function (key) {
      return String(current[key] || '') !== String(next[key] || '');
    });
  }

  async function syncCartAttributes() {
    if (syncing) return;

    var poasAttrs = buildPoasAttributes();
    if (!poasAttrs) return;

    syncing = true;
    try {
      var cartRes = await originalFetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) return;

      var cart = await cartRes.json();
      var current = cart.attributes || {};
      if (!differs(current, poasAttrs)) return;

      await originalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: Object.assign({}, current, poasAttrs) })
      });
    } catch (err) {
      console.warn('[poas-click-capture] cart attribute sync failed');
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      syncCartAttributes();
    }, 250);
  }

  window.fetch = async function () {
    var url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]);
    var res = await originalFetch.apply(this, arguments);
    if (!syncing && res.ok && /\/cart\/(add|change|update)\.js(?:\?|$)/.test(url)) {
      scheduleSync();
    }
    return res;
  };

  captureUrlParams();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();